<template>
    <div class="yandex-address">
        <div class="loader" v-show="loading"></div>

        <button class="btn btn--gray yandex-address__get-user-location" @click="getUserLocation">Определить</button>

        <div class="yandex-address__input">
            <label>
                <input
                    type="text"
                    ref="input"
                    v-model="value"

                    @input="getSuggestions()"
                    @focus="focus = true"
                    @blur="inputBlur()"

                    :data-empty="`${!value}`"
                    :class="{
                        error: status === 'not_found',
                        isDelivered: status === 'delivery',
                    }"

                    required
                >

                <span>{{ placeholder }}</span>
            </label>

            <div class="not-found" v-show="notFound === true && focus === true">Результаты не найдены</div>

            <ul ref="suggestList" class="suggest-list" v-show="suggestList.length > 0 && focus === true">
                <li
                    v-bind:key="index"
                    v-for="(item, index) in suggestList"
                    ref="suggestItem"
                    class="suggest-item"
                    :class="{ 'active' : activeItemIndex === index }"
                    @click="validateSuggest(index, true)"
                >
                    <div class="suggest-title">{{ item.title }}</div>
                    <div class="suggest-subtitle">{{ item.subtitle }}</div>
                </li>
            </ul>
        </div>

        <button class="btn btn--primary" @click="validateAddressButton" v-if="$parent.showDeliveryMap">Я здесь</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            suggestList: [],        // Массив поисковых предложений
            activeItemIndex: false, // Индекс активного элемента
            disabled: false,        // Состояния поля ввода
            notFound: false,        // Флаг отсутствия поисковых подсказок
            focus: false,           // Флаг фокусировки на поле ввода
            loading: false,         //Отправка запроса в Geocoder
            status: '',
            value: '',
        }
    },
    props: {
        // Задержка ввода (мс)
        inputDelay: {
            type: Number,
            default: 0
        },
        // Координаты углов прямоугольника приоритета поиска
        cityName: {
            type: String,
            required: true
        },
        // Координаты углов прямоугольника приоритета поиска
        bbox: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        mapValue: {
            type: String,
            default: ''
        },
    },
    watch: {
        suggestList: function () {
            this.activeItemIndex = false;

            if (this.value.length === 0 && this.suggestList.length === 0) {
                this.notFound = false;
            }
        },
        mapValue: function (value) {
            if (value.length > 0) {
                this.value = value;
            }
        }
    },
    mounted() {
        this.$refs.input.addEventListener('keydown', (e) => {
            let key = e.code;

            if (key === 'ArrowUp' && this.suggestList.length > 0) {
                e.preventDefault();

                if (this.activeItemIndex > 0) {
                    this.activeItemIndex--;
                } else {
                    this.activeItemIndex = null;
                }

                this.$refs.input.focus();

                let visibleItems = this.$refs.suggestList.clientHeight / this.$refs.suggestItem[0].clientHeight;

                if (this.activeItemIndex <= visibleItems - 1) {
                    this.$refs.suggestList.scrollTop -= this.$refs.suggestItem[0].clientHeight;
                } else {
                    this.$refs.suggestList.scrollTop = this.$refs.suggestList.scrollHeight;
                }
            }

            if (key === 'ArrowDown' && this.suggestList.length > 0) {
                e.preventDefault();

                if (this.activeItemIndex === null) {
                    this.activeItemIndex = 0;
                    return;
                }

                if (this.activeItemIndex < (this.suggestList.length - 1)) {
                    this.activeItemIndex++;
                } else {
                    this.activeItemIndex = 0;
                }

                this.$refs.input.focus();

                let visibleItems = this.$refs.suggestList.clientHeight / this.$refs.suggestItem[0].clientHeight;

                if (this.activeItemIndex >= visibleItems) {
                    this.$refs.suggestList.scrollTop += this.$refs.suggestItem[0].clientHeight;
                } else {
                    this.$refs.suggestList.scrollTop = 0;
                }
            }

            if (key === 'Enter') {
                clearTimeout(this.timer);

                if (this.activeItemIndex === 0 || this.activeItemIndex > 0) {
                    this.validateSuggest(this.activeItemIndex, true);
                    return;
                }

                this.validateSuggest(this.value, false);
            }
        });
    },
    methods: {
        getUserLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    let coords = [ position.coords.latitude, position.coords.longitude ];
                    this.$parent.getAddress(coords);
                    this.$parent.navigateTo(position.coords);
                });
            }
        },
        getSuggestions() {
            this.notFound = false;

            if (this.value.length < 2) {
                this.suggestList = [];
                this.activeItemIndex = null;
                return;
            }

            clearTimeout(this.timer);

            let data = {
                bases: 'geo,biz',
                bbox: this.bbox,
                countries: 'ru',
                fullpath: 1,
                highlight: 0,
                lang: 'ru_RU',
                local_only: 0,
                results: 7,
                text: this.value,
                type: 'addr',
                v: 9
            };

            if (this.bbox === '') {
                data.text = this.cityName + ', ' + data.text;
            } else {
                data.bbox = this.bbox;
            }

            this.timer = setTimeout(() => {
                $.ajax({
                    url: 'https://suggest-maps.yandex.ru/suggest-geo',
                    data: data,
                    dataType: "jsonp",
                })
                    .done((data) => {
                        this.suggestList = [];

                        let resultsCount = 0;
                        data.results.forEach((element, index) => {
                            if (element.tags.includes('entrance')) return;

                            if (element.personalization_info.type === 'chain' ||
                                element.personalization_info.type === 'fake_chain' ||
                                element.personalization_info.type === 'rubric' ||
                                element.type === 'query' ||
                                typeof element.subtitle === 'undefined'
                            ) {
                                return;
                            }

                            this.suggestList.push({
                                index: index,
                                title: element.title.text,
                                subtitle: ((element.type === 'business') ? element.subtitle.text.replace(' · ', ', ') : element.subtitle.text),
                                geoQuery: element.text,
                                type: element.type
                            });

                            resultsCount++;
                        });

                        if (resultsCount === 0) {
                            this.notFound = true;
                        }
                    });
            }, this.inputDelay);
        },
        validateSuggest(value, byIndex) {

            console.log(this.suggestList[value], byIndex, value);
            if (byIndex === true) {
                if (this.suggestList[value].type === 'business') {
                    this.value = this.suggestList[value].subtitle;
                } else {
                    this.value = this.suggestList[value].title;
                }
            }

            let geocode = '';

            if (byIndex === true && this.suggestList[value].type === 'business') {
                geocode = this.suggestList[value].subtitle.split(', ');
                geocode.shift();
                geocode = geocode.join(', ');
            } else if (byIndex === true && this.suggestList[value].type === 'toponym') {
                geocode = this.suggestList[value].geoQuery;
            } else if (byIndex === false) {
                geocode = this.value;
            }

            this.getCoordinatesTheCustomerAddress(geocode);

            this.suggestList = [];
        },
        validateAddressButton(event) {
            if (this.value.length < 1) return alert('Укажите адрес доставки');
            this.getCoordinatesTheCustomerAddress(this.value, true);
        },
        getCoordinatesTheCustomerAddress(address, close = false) {
            this.loading = true;
            this.status = '';

            axios.post('/api/checkAddressForDelivery', {
                address: address,
                changeOrderType: 'delivery'
            })
                .then((response) => {
                    if (response.data.found && response.data.kind !== 'house') {
                        this.value = response.data.formated + ', ';
                        this.loading = false;
                        this.status = '';

                        setTimeout(() => {
                            this.$refs.input.focus();
                            this.getSuggestions();
                        }, 100)

                        return true;
                    }

                    if (response.data.found) this.value = response.data.formated;

                    if (response.data.found && response.data.delivered) {
                        this.status = 'delivery';
                    } else {
                        this.status = 'not_found';
                    }

                    this.$root.unavailableClientAddress.show = !response.data.found || !response.data.delivered;

                    this.$parent.searchDelivery(response.data);
                    this.$parent.navigateTo(response.data.coordinates);
                })
                .catch((error) => {
                    console.error(error);
                    alert('Произошла ошибка на сервере. Мы уже исправляем ее, а пока можете обратиться на нашу горячую линию. Приносим свои извинения')
                })
                .then(() => {
                    this.loading = false;
                    if (this.status == 'delivery' && close) this.$parent.hideMap();
                });
        },
        inputBlur() {
            setTimeout(() => {
                this.focus = false;
            }, 500);
            this.$root.addr.formated = this.value;
        },
        openModal() {
            if (this.$parent.openModalOnArraw) {
                this.$root.openModal(this.$parent.openModalOnArraw, { orderType: 'delivery' });
            }
        },
    },
    created() {
        // Не реактивные данные
        this.timer = null; // Таймер задержки ввода

        //Получаем адрес из кеша
        this.status = '';
        if (this.$root.addr.formated?.length > 0) {
            this.value = this.$root.addr.formated;
        }
    }
}
</script>
